import React from "react";
import AddSite from "../../../components/AddAndEditSite/AddSite";

function AddSitePage() {
  return <AddSite />;
}

export default AddSitePage;
